import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import React,{Component} from 'react';

import './LoadingData.css';

interface Props{
    loading?: boolean
    no_data_message?: React.ReactNode|string
    no_data?: boolean
    children: any
}

export default class LoadingData extends Component<Props>{
    render(){
        if(this.props.loading) 
            return <div className="centered"><Spinner height={18}/></div>
        if(this.props.no_data) 
            return <div className="no-data">{ this.props.no_data_message || 'No Data' }</div>
        return this.props.children;
    }

};